module.exports = __webpack_public_path__ + "static/media/link-download.c6f8125c.svg";